import { Container, Graphics, Sprite } from 'pixi.js';
import { getAsset, preloadDesignAssets } from 'game/preloadGameAssets';
import { theme } from 'game/theme';
import { DesignTabs } from './DesignSection';
import { AssetLoader } from './AssetLoader';
import { GameEvent } from 'game/events/gameEvent';
import { EventName } from 'game/events/eventsName';
import { Store } from 'game/store/gameStore';
import { GAEvent, GAEventNames } from 'game/analytics/events';

export class Prev {
    public container: Container;
    public checkContainer: Container;
    public imgName: string;
    public chosenBorder: Graphics;
    public regularBorder: Graphics;
    public isChosen: boolean;
    public isLoading = false;
    public type: string;
    public mask: Graphics;

    constructor(imgFileName: string, type: DesignTabs, width: number, height: number, radius: number) {
        this.onClick = this.onClick.bind(this);
        this.isChosen = false;
        this.container = new Container();
        this.checkContainer = new Container();
        this.chosenBorder = new Graphics();
        this.regularBorder = new Graphics();
        this.imgName = imgFileName;
        this.type = type;

        type == DesignTabs.BACKS
            ? this.addImg(this.imgName, width - 6, height - 6, type)
            : this.addImg(this.imgName, width, height, type);
        this.container.addChild(this.checkContainer);
        this.checkContainer.position.set(0, 0);
        this.addCheck(width, height);
        this.checkContainer.zIndex = 1500;
        this.chosenBorder.roundRect(0, 0, width, height, radius);
        this.regularBorder.roundRect(0, 0, width, height, radius);
        this.chosenBorder.stroke({ width: 4, color: theme.chosenDesignBorder, alpha: 1, alignment: 1 });
        this.regularBorder.stroke({ width: 5, color: theme.designBorder, alpha: 0.1, alignment: 1 });
        this.chosenBorder.zIndex = 1600;
        this.regularBorder.zIndex = 1600;
        this.chosenBorder.alpha = 0;
        this.regularBorder.alpha = 0;
        this.container.addChild(this.chosenBorder);
        this.container.addChild(this.regularBorder);
        this.mask = new Graphics().roundRect(0, 0, width, height, radius).fill(0xffffff);
        this.container.mask = this.mask;
        this.container.addChild(this.mask);
    }

    addImg = async (item: string, width: number, height: number, type: DesignTabs) => {
        const spriteContainer = new Container();
        this.container.addChild(spriteContainer);

        const loader = new AssetLoader(this.container);

        let url = 'undefined';
        switch (type) {
            case DesignTabs.BACKS:
                url = `cards/back/${item}`;
                loader.setPosition(width * 0.5 + 3, height * 0.5 + 3);
                break;
            case DesignTabs.FRONTS:
                url = `cards/prev/${item}`;
                loader.setPosition(width * 0.5, height * 0.5);
                break;
            case DesignTabs.BACKGROUNDS:
                url = `backgrounds/prev/${item}`;
                loader.setPosition(width * 0.5, height * 0.5);
                break;
        }

        const img = await getAsset(url);
        this.container.eventMode = 'static';

        loader.destroy();

        const backSprite = Sprite.from(img);
        if (type == DesignTabs.BACKS) {
            backSprite.anchor.set(0.5);
            backSprite.position.set(width * 0.5 + 3, height * 0.5 + 3);
            backSprite.width = width;
            backSprite.height = height;
        } else {
            backSprite.anchor.set(0);
            backSprite.width = width;
            backSprite.height = height;
        }

        spriteContainer.addChild(backSprite);
    };

    addCheck = async (width: number, height: number) => {
        const img = await getAsset('settings/selected');
        const checkSprite = Sprite.from(img);
        checkSprite.anchor.set(0.5);
        checkSprite.scale.set(0.33333);
        checkSprite.position.set(width - 10 - checkSprite.width * 0.5, height - 10 - checkSprite.height * 0.5);
        this.checkContainer.addChild(checkSprite);
    };

    onClick() {
        switch (this.type) {
            case DesignTabs.BACKS:
                Store.setBack(this.imgName);
                preloadDesignAssets(this.type, EventName.CHANGE_CARD_BACK);

                GAEvent(GAEventNames.GAME_DESIGN_BACK, {
                    number: this.imgName,
                });

                break;
            case DesignTabs.FRONTS:
                Store.setFront(this.imgName);
                preloadDesignAssets(this.type, EventName.CHANGE_CARD_FRONT);
                GAEvent(GAEventNames.GAME_DESIGN_FRONT, {
                    number: this.imgName,
                });
                break;
            case DesignTabs.BACKGROUNDS:
                Store.setBackground(this.imgName);
                GameEvent.emit(EventName.CHANGE_BG);
                GAEvent(GAEventNames.GAME_DESIGN_BACKGROUND, {
                    number: this.imgName,
                });
        }
        this.chosenBorder.alpha = 1;
        this.regularBorder.alpha = 0;
        this.checkContainer.alpha = 1;
    }
    uncheck() {
        this.chosenBorder.alpha = 0;
        this.regularBorder.alpha = 1;
    }
    select() {
        this.chosenBorder.alpha = 1;
        this.regularBorder.alpha = 0;
    }
}
